const PARTNER_CENTER_SETTINGS_URL = 'settings';
const BUSINESS_APP_SETTINGS_URL = 'inbox';

export function getBackUrl(isBusinessApp: boolean, levelsDeep: number): string {
  const centerUrl = isBusinessApp ? BUSINESS_APP_SETTINGS_URL : PARTNER_CENTER_SETTINGS_URL;
  let url = '';
  for (let i = 0; i < levelsDeep; i++) {
    url += '../';
  }
  return `${url}${centerUrl}`;
}
